import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyDropdownComponent } from './company-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [CompanyDropdownComponent],
  exports: [CompanyDropdownComponent]
})
export class CompanyDropdownModule { }
